import axios from "axios";
import React, { useState } from "react";
import { useParams } from "react-router-dom";

export default function Redirect() {
    const params = useParams();
    const { uid } = params;
    const [status, setStatus] = useState(0);

    axios
        .get(`${process.env.REACT_APP_API_URL}redirect?link=${uid}`)
        .then((response) => {
            if (response.status === 200) {
                window.location.replace(response.data);
            } else {
                setStatus(response.status);
            }
        })
        .catch((error) => {
            setStatus(error.response.status);
        });
    return (
        <>
            <h1>{status < 400 ? "Redirecting..." : "Error " + status}</h1>
            {status > 0 && <p>{status === 404 ? "This redirect URL is not in use" : "Error code " + status}</p>}
        </>
    );
}
